import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Ionicons } from '@expo/vector-icons';
import { SafeAreaProvider } from 'react-native-safe-area-context'; // <-- 1. Bunu ekle

import HomeScreen from './screens/HomeScreen';
import AddScreen from './screens/AddScreen';
import ReportsScreen from './screens/ReportsScreen';
import { VehicleProvider } from './context/VehicleContext';

const Tab = createBottomTabNavigator();

export default function App() {
  return (
    <VehicleProvider>
      {/* 2. Tüm navigasyonu SafeAreaProvider içine al */}
      <SafeAreaProvider> 
        <NavigationContainer>
          <Tab.Navigator
            screenOptions={({ route }) => ({
              headerShown: false, // Üstteki varsayılan başlığı gizledik
              tabBarIcon: ({ focused, color, size }) => {
                let iconName;
                if (route.name === 'Araç Listesi') iconName = focused ? 'car-sport' : 'car-sport-outline';
                else if (route.name === 'Plaka Girişi') iconName = focused ? 'add-circle' : 'add-circle-outline';
                else if (route.name === 'Raporlar') iconName = focused ? 'bar-chart' : 'bar-chart-outline';
                return <Ionicons name={iconName} size={size} color={color} />;
              },
              tabBarActiveTintColor: 'blue',
              tabBarInactiveTintColor: 'gray',
            })}
          >
            <Tab.Screen name="Araç Listesi" component={HomeScreen} />
            <Tab.Screen name="Plaka Girişi" component={AddScreen} />
            <Tab.Screen name="Raporlar" component={ReportsScreen} />
          </Tab.Navigator>
        </NavigationContainer>
      </SafeAreaProvider>
    </VehicleProvider>
  );
}